import { CalendarDays, Compass, Store, type LucideIcon } from 'lucide-react'
import { DEFAULT_VERTICAL, type Vertical } from './useVertical'

export type DiscoveryTab = {
  label: string
  path: string
  icon: LucideIcon
}

// Discovery tabs are scoped to the active vertical: each vertical surfaces its
// own discovery routes. The header reads the active vertical and renders the
// matching set (see design/38_thrifts_vertical_plan.md §9).
//
// Thrifts, Stays, and Moves use a single discovery surface and hoist a search
// pill into a vertical-specific header (ThriftDiscoveryFrame, etc.), so they
// keep an empty tab list here — a lone "Moves"/"Thrifts" tab is redundant with
// the brand mark.
export const DISCOVERY_TABS_BY_VERTICAL: Record<Vertical, DiscoveryTab[]> = {
  farm_to_table: [
    { label: 'Marketplace', path: '/marketplace', icon: Store },
    { label: 'Explore Creations', path: '/explore-farms', icon: Compass },
    { label: 'Upcoming Events', path: '/upcoming-events', icon: CalendarDays },
  ],
  stays: [],
  thrifts: [],
  moves: [],
}

export function getDiscoveryTabs(vertical: Vertical): DiscoveryTab[] {
  return DISCOVERY_TABS_BY_VERTICAL[vertical] ?? DISCOVERY_TABS_BY_VERTICAL[DEFAULT_VERTICAL]
}
